<script lang="ts" setup>
import { VButtonTarget } from '~/components/v-button/VButton.vue'

export interface WidgetWizardItemButtonProps {
    active: boolean
    target: VButtonTarget
    data: WizardData
}

export interface WidgetWizardItemButtonEmits {
    (e: 'select', value: boolean): void
    (e: 'tab', value: KeyboardEvent): void
    (e: 'focus'): void
}

const props = defineProps<WidgetWizardItemButtonProps>()
const emit = defineEmits<WidgetWizardItemButtonEmits>()
const { data: gaEventData, sendEvent } = useTracker()

const handleSelect = (autofocus: boolean): void => {
    emit('select', autofocus)
    sendEvent({
        data: {
            ...gaEventData,
            click: props.data.title,
        },
    })
}
</script>

<template>
  <button
    class="wizard-item transition rounded box-shadow-1 px-4 h-100 w-100 position-relative d-flex flex-column gap-4 justify-content-center"
    :aria-current="props.active"
    :class="{
      'py-10': Boolean(props.data.icon),
      'py-14': !Boolean(props.data.icon),
    }"
    @keydown.enter.prevent="handleSelect(true)"
    @keydown.tab.prevent="(e: KeyboardEvent) => emit('tab', e)"
    @click.prevent="handleSelect(false)"
    @focus="emit('focus')"
  >
    <img
      v-if="props.data.icon"
      :src="props.data.icon.path"
      width="24"
      height="24"
      class="wizard-item-image ms-2"
      aria-hidden="true"
      alt=""
    >
    <span
      class="fs-normal fw-bolder wizard-item-title mb-0 text-start d-flex align-items-center"
    >
      {{ props.data.title }}
      <span
        v-if="props.target === '_blank'"
        class="visually-hidden"
      >{{ $t(" - externý odkaz") }}</span>
      <svg
        v-if="props.target === '_blank'"
        class="btn-icon d-block ms-3 flex-shrink-0"
        width="16"
        height="16"
        aria-hidden="true"
      >
        <use xlink:href="#external" />
      </svg>
    </span>
  </button>
</template>

<style lang="scss" scoped>
@import '../WidgetWizardItem.scss';
</style>
